'use client';

import Bot from '@/views/bot';
import { PlanGate } from '@/components/shared/PlanGate';
import { FeatureGate } from '@/components/shared/FeatureGate';
import { BotMessageSquareIcon } from 'lucide-react';

const BotPage = () => {
  return (
    <FeatureGate
      module="marketing"
      title="Marketing Hub Not Available"
      description="AI Chatbot is only available when Marketing Hub is enabled for your workspace."
      icon={BotMessageSquareIcon}
    >
      <PlanGate
        requiredPlan="enterprise"
        title="AI Chatbot — Enterprise Feature"
        description="AI-powered chatbot with custom personas, training data, and demo booking is available on the Enterprise plan."
        icon={BotMessageSquareIcon}
      >
        <Bot />
      </PlanGate>
    </FeatureGate>
  );
};

export default BotPage;
